import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommentBO, EventEmitterTicketsBo, GetEngementBO, LinkEngagement, LinkInbox, TicketAttachmentsBO, TicketsBO, User } from '../ticket.model';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonApiService } from 'src/app/commonapiservice';

import { takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { GlobalComponent } from 'src/app/global/global.component';
import { ToastrService } from 'ngx-toastr';
import { LovBO } from '../../client-employee-document/client-employee-document.model';
import { ChangeDetectorRef } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import * as base64 from 'base64-js';
import { DataStateChangeEventArgs, FilterSettingsModel, GridComponent, IFilter } from '@syncfusion/ej2-angular-grids';
import { ColumnChangeBO } from '../../eligibility270/eligibility270.model';
import { TicketEntryService } from './ticket-entry.service';
import { columnWidth } from '../../users/users.model';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpBackend, HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-ticket-entry',
  templateUrl: './ticket-entry.component.html',
  styleUrls: ['./ticket-entry.component.scss'],
})
export class TicketEntryComponent implements OnInit {


  private onDestroy$: Subject<void> = new Subject<void>();

  name = 'Angular';
  AllClientDropDownList: any = [];
  AllEmployeeDropDownList: any = [];
  EmployeeDropdown: any = [];
  locationLid: any = 0;
  listId: any;
  lovForm: FormGroup;
  tagsname: any = [];
  @Input() EntryInputProperty: EventEmitterTicketsBo = new EventEmitterTicketsBo();
  @Output() EntryOutputTimesheet = new EventEmitter<EventEmitterTicketsBo>();
  close: boolean = false;
  ticketsForm: FormGroup;
  Tickets: TicketsBO = new TicketsBO();
  ListSendBO = new GetEngementBO();
  LinkEngagement: LinkEngagement = new LinkEngagement();
  LinkInbox: LinkInbox = new LinkInbox();
  @ViewChild('engagementgrid') public engagementgrid: GridComponent;
  @ViewChild('inboxgrid') public inboxgrid: GridComponent;
  InboxGrid: any[];
  EngagementGrid: any[];
  id: string = "00000000-0000-0000-0000-000000000000";
  arraycol: any = [];
  public GridDataList: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;

  @ViewChild('childtemplate') public childtemplate: any;
  // @ViewChild('grid') public grid: GridComponent;
  @ViewChild('grid') public grid: GridComponent;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public formatOptions: object;


  ColumnArray: columnWidth[];
  filterOptions: FilterSettingsModel;
  initialPage: object;
  filter: IFilter;
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  mappedId: any;
  unlink : string;
  AllClientDropDownListwithStatus: any;
    messages ;
    private httpNoInterceptor: HttpClient;
    audioUrl ;
    @ViewChild('audioRef') audioRef!: ElementRef<HTMLAudioElement>;
     @Input() clientTab: string;



  constructor(private formBuilder: FormBuilder, public CommonAPI: CommonApiService, public global: GlobalComponent, public toastrService: ToastrService,
    private changeDetectorRef: ChangeDetectorRef, private sanitizer: DomSanitizer, public service: TicketEntryService ,private http: HttpClient, handler: HttpBackend
  ) {
    this.httpNoInterceptor = new HttpClient(handler);  
    this.GridDataList = service;
    this.lovForm = this.formBuilder.group({
      Name: ['', Validators.required],
    });
    this.ticketsForm = this.formBuilder.group({
      id: ['00000000-0000-0000-0000-000000000000'],
      title: ['', Validators.required],
      description: ['', Validators.required],
      assignee: ['', Validators.required],
      tickettype: ['', Validators.required],
      status: ['', Validators.required],
      priority: [''],

    });
  }

  isEditorActive = false;
  isEditorActiveComments = false;
  customertype = [
    { key: 'Employee', value: 'Employee' },
    { key: 'Client', value: 'Client' },
  ]
  ////////////////// comments variables/////////////////
  comments: CommentBO[] = [];
  showFilter = 'comments';
  newCommentText = '';



  StatusList: any = [];
  PriorityList: any = [];
  TypesList: any = [];


  Lov: LovBO = new LovBO();

  currentUser: any;
  currentuserFirstletter: any;
  EngagementDropdown: any = [];
  InboxDropdown: any = [];
  editorConfig = {
    // Optional: Configure editor settings here
    // https://ckeditor.com/docs/ckeditor5/latest/api/ckeditor.html
  }; // Configuration object for CKEditor

  ngOnInit() {
    console.log(this.clientTab)

    if (this.global.globalLocationId != null && this.global.globalLocationId != ''
      && this.global.globalLocationId != undefined) {
      this.locationLid = this.global.globalLocationId;
    }
    else {
      this.locationLid = "00000000-0000-0000-0000-000000000000";
    }
    this.getpermission();
    this.getEmployeeDropdown();
    this.getPriorityList();
    this.getStatus();
    this.getTickettypes();  
    this.Tickets = new TicketsBO();
    this.getAllClient(); 
    this.filterOptions = { type: 'Menu' };
    this.filter = {
      type: 'menu'
    };
    this.formatOptions = { type: 'datetime', format: 'MM/dd/yyyy hh:mm:ss a' };
    let pag = 10;
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: pag, pageSize: pag, pageSizes: this.pageSizes };

    if (this.EntryInputProperty.isEdit == true) {  
      this.isEditorActive = true;
      this.isEditorActiveComments = true;
      this.ticketsForm.get('id').setValue(this.EntryInputProperty.tickets.id);
      this.LinkEngagement.ticketId = this.EntryInputProperty.tickets.id;
      this.LinkInbox.ticketId = this.EntryInputProperty.tickets.id;
      
      this.Tickets.tags = this.EntryInputProperty.tickets.tags;
      this.GetEngagementList();
      this.GetInboxList();
      this.getEngagementdd();
      this.getInboxdd();
      //   this.getticketattachments();

      // this.ticketsForm.controls['description'].setValue(this.EntryInputProperty.tickets?.summary);
      // this.ticketsForm.controls['assignee'].setValue(this.EntryInputProperty.tickets?.employeeId);
      // this.ticketsForm.controls['tickettype'].setValue(this.EntryInputProperty.tickets?.ticketTypeLid);
      // this.ticketsForm.controls['status'].setValue(this.EntryInputProperty.tickets?.statusLid);
      // this.ticketsForm.controls['priority'].setValue(this.EntryInputProperty.tickets?.priorityLid);
      // this.ticketsForm.controls['title'].setValue(this.EntryInputProperty.tickets?.title);
      this.Tickets = this.EntryInputProperty.tickets;
      console.log(this.Tickets)
      this.Tickets.id = this.EntryInputProperty.tickets.id;
      // this.Tickets.tags = this.EntryInputProperty.tickets.tags;
      // this.Tickets.priorityLid = this.EntryInputProperty.tickets?.priorityLid;
      // this.Tickets.ticketStatusLid = this.EntryInputProperty.tickets?.ticketStatusLid;
      // this.Tickets.ticketTypeLid = this.EntryInputProperty.tickets?.ticketTypeLid;
      // this.currentuserFirstletter = this.currentUser?.charAt(0);
    }
  }



  content: string = '';


  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.toastrService.success("Copied to clipboard")
    }).catch(err => {
      console.error('Could not copy text: ', err);
    });
  }
    fp:any;
    getpermission() {
       let params = new URLSearchParams();
        params.append("pagecode", "TICKET");    
       let url = "api/FunctionPermission/getfunctionpermissionemployee?";
       this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
         if (data != null) {
           this.fp = data;
         }
         else {
           this.fp = null;
         }
       },
         (err: HttpErrorResponse) => {
           this.fp = null;
         })
     }

  toggleEditor() {
    this.isEditorActive = true;
  }

  toggleEditorForcomments() {
    this.isEditorActiveComments = true;
  }
  ngAfterViewInit() {

  }



  selectedFiles: File[] = [];

  onFilesSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files) {
      this.selectedFiles = Array.from(input.files);
    }

  }

  files: File[] = [];
  async onFileSelected(event: any) {
    const selectedFiles = event.target.files;
    for (let i = 0; i < selectedFiles.length; i++) {
      const file = selectedFiles[i];


      let basevalue: any;
      if (file != null && file != undefined) {
        basevalue = await this.tobase64(file);
        file.fileString = basevalue;
        file.fileName = file.name
        file.filePath = file.name
      }
      // let value : TicketAttachmentsBO={
      //   id: 0,
      //   fileName: file.name,
      //   filePath: file.name,
      //   ticketId: 0,
      //   fileString: basevalue
      // }
      if (this.EntryInputProperty.tickets.id == '00000000-0000-0000-0000-000000000000') {
        this.Tickets.ticketAttachments.push(file);
      }

      this.files.push(file);
    }
  }

  filePreview: string[] = [];
  onFileSelected_new(event: any) {
    const files: FileList = event.target.files;
    this.selectedFiles = Array.from(files);

    this.filePreview = [];
    for (let file of this.selectedFiles) {
      if (file.type.includes('image')) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.filePreview.push(e.target.result);
        };
        reader.readAsDataURL(file);
      }
    }
  }
  removeFile(fileToRemove: File) {
    this.files = this.files.filter(file => file !== fileToRemove);
    this.Tickets.ticketAttachments = this.Tickets.ticketAttachments.filter(file => file.fileName !== fileToRemove.name);
  }


  formatBytes(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
  // onDOCFileChanged(files) {
  //   let val = files.item(0);
  //   this.documentList.fileString = files.item(0);
  //   this.selectedDocumentFileName = files.item(0).name;
  // }

  // inputChangeValue() {
  //   this.clientInputChange = true;
  // }
  SaveOrUpdate() {
  }

  cancel() {
  }
  //................................................backtoTickettView................................................................
  backtoTicketView() {

    if (this.ticketclose == true) {
      document.getElementById("OpenWithoutSaveTickets").click();
    }
    else {

      this.cleartickets();
      this.EntryInputProperty.isEntry = null;
      this.EntryOutputTimesheet.emit(this.EntryInputProperty);
    }
  }
  //.................................................backwithalert........................................................
  backwithalert() {
    this.backtoTicketView()
  }

  attachmentsList: any = [];
  //.................................................getAttachments........................................................
  getticketattachments() {
    let params = new URLSearchParams();
    params.append("ticketId", this.EntryInputProperty.tickets.id.toString());
    let url = "api/Tickets/GetTicketAttachments?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.attachmentsList = data;
      this.attachmentsList.forEach(element => {
        element.name = element.fileName
      });
      //   this.files = this.attachmentsList;
      this.Tickets.ticketAttachments = this.attachmentsList;
      this.files = this.attachmentsList;
    });
  }


  //.................................................getAllEmployeeDropDown........................................................


  //.................................................UsersDropdown........................................................
  getEmployeeDropdown() {
    let myParams = new URLSearchParams();
    // myParams.append("LocationId", this.locationId.toString());
    let url = "api/Employee/employeeDropDown?";
    this.CommonAPI
      .GetFunctionwithResponseTypeJson(myParams, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        data.forEach((element) => {
          element.Value = element.Value;
          element.Key = element.Key.toString();
        });
        this.EmployeeDropdown = data;
      });
  }

  //.................................................getStatus........................................................
  getStatus() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "TICKETSTATUS");
    this.CommonAPI.getDropDownList("TICKETSTATUS", params, url, "LovDropDown").then(
      (data: any) => {
        this.StatusList = data;
      },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    );
  }


  Taglist: any = [];
  //.................................................gettags........................................................
  //   getTags() {
  //     let url = "api/LOV/getLovDropDown?"
  //     let params = new URLSearchParams();
  //     params.append("Code", "TAGS");
  //     this.CommonAPI.getDropDownList("TAGS", params, url, "LovDropDown").then(
  //       (data: any) => {
  //         this.Taglist = data;
  //       },
  //       (err: any) => {
  //         this.toastrService.error(err);
  //         setTimeout(() => {
  //           this.toastrService.clear();
  //         }, 8000);
  //       }
  //     );
  //   }
  //.................................................getPriorityList........................................................
  getPriorityList() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "TICKETPRIORITY");
    this.CommonAPI.getDropDownList("TICKETPRIORITY", params, url, "LovDropDown").then(
      (data: any) => {
        this.PriorityList = data;
      

      },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    );
  }


  //.................................................getPriorityList........................................................
  getTickettypes() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "TICKETTYPE");
    this.CommonAPI.getDropDownList("TICKETTYPE", params, url, "LovDropDown").then(
      (data: any) => {
        this.TypesList = data;

      },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    );
  }

  ticketclose: boolean = false;

  ChangeTitle() {
   
  }


  downloadFile(data) {
    var data1 = data.document;
    if (data1 != null) {
      window.open(data1);
    }
  }


  async downloadUnsavedFile(file) {
    let basevalue: any;
    if (file != null && file != undefined) {
      basevalue = await this.tobase64(file);
      // element.fileString = basevalue;
    }
    const base64Data = 'YOUR_BASE64_STRING_HERE';
    const blob = this.base64ToBlob(basevalue);
    const url = window.URL.createObjectURL(blob);
    // Get the file extension
    const fileExtension = file.name.split('.').pop() || '';

    const link = document.createElement('a');
    link.href = url;
    link.download = `viewfile.${fileExtension}`; // Use the extracted extension
    link.click();

    window.URL.revokeObjectURL(url);
  }

  private base64ToBlob(base64String: string): Blob {
    try {
      // Remove data URL prefix if present
      const base64Content = base64String.split(',')[1] || base64String;

      // Decode base64 to byte array
      const byteArray = base64.toByteArray(base64Content);

      // Create blob from byte array
      return new Blob([byteArray], { type: 'application/octet-stream' });
    } catch (error) {
      console.error('Error in base64ToBlob:', error);
      throw error;
    }
  }
  /////////////////=================Tag lov Save==================================/////////////////////


  clearlov() {
    this.lovForm.reset();
  }
  saveLov(listParam) {
    let val = listParam.lovName.replace(/\s/g, "");
    let url = "api/LOV/SaveLov";

    let obj = {
      ListId: this.listId,
      Id: listParam.Id,
      lovCode: val.toUpperCase(),
      lovName: listParam.lovName,
      lovValue: null,
      orderby: 0,
    }
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(obj, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      //   this.getTags();
      
      this.toastrService.success(
        "Tag created successfully!"
      );
      setTimeout(() => {
        this.toastrService.clear()
      }, 8000);
      document.getElementById("DocumentsLovopen").click()
    },
      (err: any) => {
        this.toastrService.error(
          err,
          "error",
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);

      })


  }



  cleartickets() {
    this.lovForm.reset();
  }
  savetickets(ticketsparam: TicketsBO) {
    console.log(ticketsparam);
    const formValue = this.ticketsForm.value;
    let url;
    url = "api/Ticket/SaveTicket";

    // this.Tickets.ticketAttachments= this.files;
    // if (this.Tickets.ticketAttachments.length == 0) {
    //   this.files.forEach(async element => {
    //     let value = {
    //       fileName: element.name,
    //       filePath: element.name,


    //     }
    //   });

    // }
   this.Tickets = ticketsparam;
    ticketsparam.ticketAttachments = ticketsparam?.ticketAttachments;
    console.log(formValue.id);
    let obj = {
      id: formValue.id,
      title: formValue.title,
      summary: formValue.description,
      priorityLid: formValue.priority,
      ticketStatusLid: formValue.status,
      ticketTypeLid: formValue.tickettype,
      employeeId: formValue.assignee,

    }
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.Tickets, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      //  this.DocumentDropdown();
      if(this.ticketsForm.get('id').value == '00000000-0000-0000-0000-000000000000')
      this.toastrService.success(
        "Ticket Created successfully!"
      );  
      else{
        this.toastrService.success(
          "Ticket Updated successfully!"
        ); 
      }
        
      this.ticketsForm.get('id').setValue(data);
      this.LinkEngagement.ticketId = data.id;
      this.LinkInbox.ticketId = data.id;
      this.Tickets.id = data.id;
      this.Tickets.uniqueTicketId = data.uniqueTicketId;
      console.log(data);
       
      this.ticketclose = false;
      setTimeout(() => {
        this.toastrService.clear()
      }, 8000);
      //   document.getElementById("DocumentsLovopen").click()
    },
      (err: any) => {
        this.toastrService.error(
          err,
          "error",
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);

      })


  }
  tobase64 = value => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(value);
    reader.onload = (e: any) => resolve(e.target.result);
    reader.onerror = error => reject(error);
  });
  Tags: any = []

  get tagsArray() {
    return this.ticketsForm.get('tags') as FormArray;  // Getter to access the tags FormArray
  }
  onvalChange() {
    const selectedTags = this.tagsArray.value;
  }





  //................................................... dataStateChange.................................................

  type: string;
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.ListSendBO.orderColumn = state.sorted[0].customerName;
        this.ListSendBO.orderType = state.sorted[0].direction === 'descending' ? 'desc' : 'asc';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.ListSendBO.field = state.action.currentFilterObject.field;
      this.ListSendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.ListSendBO.operator = state.action.currentFilterObject.operator;
      this.ListSendBO.value = state.action.currentFilterObject.value;
      if (this.ListSendBO.type == "number") {
        this.ListSendBO.value = state.action.currentFilterObject.value.toString();
        this.ListSendBO.field = state.action.currentFilterObject.field;
      }
      else if (this.ListSendBO.type == "date") {
        this.ListSendBO.value = this.global.getDateTimeString(state.action.currentFilterObject.value);
        this.ListSendBO.field = state.action.currentFilterObject.field;
      }
      else {
        this.ListSendBO.value = state.action.currentFilterObject.value;
        this.ListSendBO.field = state.action.currentFilterObject.field;
      }
      this.ListSendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.ListSendBO.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.ListSendBO.field = "CustomerName";
        this.ListSendBO.matchCase = false;
        this.ListSendBO.operator = "startswith";
        this.ListSendBO.value = "";
        this.ListSendBO.type = "string";
      }
    }
    if (this.type != "refresh") {
      //    this.GetEngementsList();
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Engements.Pagesize != state.take) {
          this.arraycol[0].Engements.Pagesize = state.take

        }

      }

    }

  }

  //.................................................onActionComplete........................................................
  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.grid.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].Engements.ShowColumns.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });

          });

          this.arraycol[0].Engements.HideColumns.forEach(old => {
            hidearr.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (this.arraycol[0].Engements.ShowColumns.length != count1 || this.arraycol[0].Engements.HideColumns.length != count) {
            this.arraycol[0].Engements.ShowColumns = showarr;
            this.arraycol[0].Engements.HideColumns = hidearr;
            this.arraycol[0].Engements.Pagesize = this.grid.pagerModule.pagerObj.pageSize

          }
        }
      }
    }
    if (args.requestType == "filterafteropen") {
      this.ListSendBO.type = args.columnType;
    }
  }

  //.............................................. openColumnChooser..................................
  show() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }


  //////////////////Get call for Engements
  EngementsList: any = [];
  GetEngementsList() {
    let val = 0;
    let url = "api/Tickets/GetEngements"
    let responseData =
    {
      result: "result",
      count: "count",
    }
    var formval = this.ticketsForm.value;
    this.ListSendBO.ticketId = this.EntryInputProperty.tickets.id
    this.service.executeViewList(this.ListSendBO)

    this.GridDataList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.EngementsList = data.result;
      val++;

    });
  }
  getEngagementdd() {
    let myParams = new URLSearchParams();
    let url = "api/EngagementLogs/EngagementDropdown?";
    this.CommonAPI
      .GetFunctionwithResponseTypeJson(myParams, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        data.forEach((element) => {
          element.Value = element.Value;
          element.Key = element.Key.toString();
        });
        this.EngagementDropdown = data;
      });

  }
  getInboxdd() {
    let myParams = new URLSearchParams();
    let url = "api/EngagementLogs/InboxDropdown?";
    this.CommonAPI
      .GetFunctionwithResponseTypeJson(myParams, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        data.forEach((element) => {
          element.Value = element.Value;
          element.Key = element.Key.toString();
        });
        this.InboxDropdown = data;
      });
  }
  LinkEngagementList() {
    let url;
    url = "api/EngagementLogsTicketsMapping/MapEngagementLogsToTicket";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.LinkEngagement, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success("Engagement Linked Successfully");

      document.getElementById('openlinkEngagement').click();
      this.LinkEngagement.engagementLogsIds = [];
      this.GetEngagementList();

    },
      (err: any) => {
        this.toastrService.error(err);
      })

  }
  LinkInboxList() {
    let url;
    url = "api/EngagementLogsTicketsMapping/MapEngagementLogsToTicket";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.LinkInbox, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success("Inbox Linked Successfully");

      document.getElementById('openlinkInbox').click();
      this.LinkInbox.engagementLogsIds = [];
      this.GetInboxList();
    },
      (err: any) => {
        this.toastrService.error(err);
      })

  }
  GetEngagementList() {
    let myParams = new URLSearchParams();
    myParams.append("Id", this.LinkInbox.ticketId)
    let url;
    url = "api/EngagementLogsTicketsMapping/GetMappedEngagementforTicket?";
    this.CommonAPI.saveorUpdateFunctionwithParams(myParams, url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.EngagementGrid = data;
    },
      (err: any) => {
        this.toastrService.error(err);
      })
  }
  GetInboxList() {
    let myParams = new URLSearchParams();
    myParams.append("Id", this.LinkEngagement.ticketId)
    let url;
    url = "api/EngagementLogsTicketsMapping/GetMappedInboxforTicket?";
    this.CommonAPI.saveorUpdateFunctionwithParams(myParams, url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.InboxGrid = data;
    },
      (err: any) => {
        this.toastrService.error(err);
      })
  }
  selectedItem(data) {
    this.mappedId = data.mappedId;

  }
  DeleteTickets() {
    let myParams = new URLSearchParams();
    myParams.append("Id", this.mappedId)
    let url;
    url = "api/EngagementLogsTicketsMapping/DeleteEngagementLogTicketMapping?";
    this.CommonAPI.saveorUpdateFunctionwithParams(myParams, url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.GetEngagementList();
      this.GetInboxList();
      document.getElementById('OpenDeletetickets').click();
    },
      (err: any) => {
        this.toastrService.error(err);
      })
  }
     getAllClient() {
     
    let param = new URLSearchParams();

    let locId;
    if (this.global.globalLocationId != null && this.global.globalLocationId != ''
      && this.global.globalLocationId != undefined) {
      locId = parseInt(this.global.globalLocationId);
    }
    else {
      locId = "00000000-0000-0000-0000-000000000000";
    }
    param.append("LocationId", locId);
    let url = "api/Client/GetAllClientsDropDownbyAgency?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any[]) => {
     this.AllClientDropDownListwithStatus = JSON.parse(JSON.stringify(data));
      this.AllClientDropDownListwithStatus.forEach(record => {
          record.Key = record.id.toString();
          record.Value = record.names + " (" + record.status + ")";
          
          if (record.medicaid) {
            record.Value += " (" + record.medicaid + ")";
          }
        });                  
    })
    console.log(this.AllClientDropDownListwithStatus)
   
     if(this.clientTab == 'clienttab')
      {
        this.Tickets.clientId = this.global.clientId;
      }
       console.log(this.Tickets.clientId)
  }
   getmedia(engagementid: string) {
  const url = 'api/EngagementLogs/GetRecordingStreamingURL?';
  const params = new URLSearchParams();
  params.append('EngagementId', engagementid);

  this.CommonAPI.GetFunctionwithResponseTypeJson(params, url)
    .pipe(takeUntil(this.onDestroy$))
    .subscribe((data: any) => {
      console.log(data);
      if (data?.fileExtention === '.txt') {
        this.loadChatHistory(data?.recording_Url);
      }
      else if(data?.fileExtention === ".mp3"){
          this.loadCallRecording(data?.recording_Url);
      }
    },(error)=>{
      this.toastrService.error(error)
    });
}

async loadChatHistory(blobUrl: string) {
  try {
    const data = await new Promise<string>((resolve, reject) => {
      this.httpNoInterceptor
        .get(blobUrl, { responseType: 'text' })
        .subscribe(resolve, reject);
    });

    try {
      this.messages = JSON.parse(data);
    } catch {
      this.messages = data;
    }

    document.getElementById('showChathistory')?.click();
  } catch (error) {
    this.toastrService.error(error)
    console.error('Error loading chat history:', error);
  }
}

loadCallRecording(url){
  this.audioUrl = url;
  document.getElementById('showCallhistory')?.click();

}
stopAudio(){
  this.audioRef?.nativeElement?.pause();
}
}
